import {AuthActionType} from '../actions/actionTypes';

const setUser = (dispatch, data) => {
  dispatch({type: AuthActionType.SET_USER, data});
};

export {setUser};
